import { Observable } from 'rxjs';
import { FusionApiHttpClient } from '../../shared/_services/server-clients';
import { InventoryPackage } from '../../shared/_models/models';

export type CreateInventoryPackagePayload = {
  description: string;
  publisher: { publisherId: number };
  packageConfigType: string;
  placements?: number[];
  excludedPlacements: number[] | null;
  selectAllPlacements: boolean;
  includeFuturePlacements: boolean;
  filterApp: 0 | 1;
  filterSite: 0 | 1;
  filterImpType: string;
  filterDeviceType: string;
  geoTargeting: null | {
    countries: unknown[];
    regions: unknown[];
    metros: unknown[];
    zipCodes: unknown[];
  };
  kvpTargeting: unknown[];
  filterDomainBundle: string | null;
  domainBundlePayload: { addedDomainBundles: unknown[]; removedDomainBundles: unknown[]; updatedDomainBundles: unknown[] };
  [key: string]: unknown;
};

export function buildInventoryPackageFormData(payload: CreateInventoryPackagePayload): FormData {
  const formData = new FormData();
  formData.append('file', new Blob());
  formData.append('payload', JSON.stringify(payload));
  return formData;
}

export class InventoryPackagesApiService {
  constructor(private readonly fusionApiHttpClient: FusionApiHttpClient) {}

  createInventoryPackage(formData: FormData): Observable<InventoryPackage> {
    return this.fusionApiHttpClient.plain.post<InventoryPackage, FormData>('dealPackage/', formData);
  }

  deleteInventoryPackage(packageId: number): Observable<void> {
    return this.fusionApiHttpClient.plain.delete<void>(`dealPackage/${packageId}`);
  }
}
